import { createContext } from 'react';
import type { ToastInput } from './ToastProvider';

type ToastFn = {
  (input: ToastInput): void;
  success: (title: string, description?: string) => void;
  error: (title: string, description?: string) => void;
  warning: (title: string, description?: string) => void;
  info: (title: string, description?: string) => void;
};

export type { ToastFn };

export const ToastContext = createContext<ToastFn | null>(null);
